import { Story } from '@/analytics/ga';
import GA from '@/analytics/ga/components/GA';
import Button from '@/components/core/Button/Button';
import Heading from '@/components/core/Heading/Heading';
import AddPost from '@/components/features/posts/AddPost/AddPost';
import Filter from '@/components/features/posts/Filter/Filter';
import PostItem from '@/components/features/posts/PostItem/PostItem';
import PostsContainer from '@/components/features/posts/PostsContainer/PostsContainer';
import { IStoryResource } from '@/interfaces/IStoryResource';
import { withTranslation, WithTranslation } from 'next-i18next';
import { NextRouter, withRouter } from 'next/router';
import React, { Component } from 'react';
import styles from './StoriesPosts.module.scss';

interface WithRouterProps {
	router: NextRouter;
}

interface IStoriesPostsProps extends WithTranslation, WithRouterProps {
	posts: Array<IStoryResource>;
	meta: any;
	onLoadMore: () => void;
	hasMore: boolean;
	loading: boolean;
}

const getSlug = (item: IStoryResource) => {
	return item.slug || item.id;
};

const getStoriesItems = (data: Array<IStoryResource>) => {
	return data.map((item) => <PostItem data={item} key={item.id} withActions to={'share/' + getSlug(item)} />);
};

class StoriesPosts extends Component<IStoriesPostsProps> {
	render() {
		const { posts, t, onLoadMore, meta, hasMore, loading, router } = this.props;

		const onFilterChange = (filter) => {
			if (filter) {
				router.replace({ query: { filter: filter } }, undefined, { scroll: false });
			}
		};

		const filterNames = {
			trending: 'trending',
			recent: 'recent',
			nearby: 'nearby',
			locked: 'locked',
		};

		const pin = (
			<GA event={Story.addStory} key={'pin'}>
				<AddPost text={'pinshare-a-story'} icon={'/assets/icons/heart-broken.svg'} to="share-story" />
			</GA>
		);

		return (
			<div className={styles.posts}>
				<Heading text={`${t('stories')} (${meta.totalCount})`}>
					<Filter onFilterChange={onFilterChange} collection={meta.filters} labels={filterNames} />
				</Heading>
				<div className={styles.postsContent}>
					<PostsContainer>{[pin, ...getStoriesItems(posts)]}</PostsContainer>
					{hasMore ? (
						<div className={styles.postsAction}>
							<Button onClick={onLoadMore} color={Button.color.PRIMARY} size={Button.size.BIG} loading={loading}>
								{t('load-more')}
							</Button>
						</div>
					) : null}
				</div>
				{hasMore ? <p className={styles.panelSeparator}>{t('or')}</p> : null}
			</div>
		);
	}
}

export default withTranslation()(withRouter(StoriesPosts));
